export const COUPON_INFO = 'COUPON_INFO'
export const UPDATE_COUPON_INFO = 'UPDATE_COUPON_INFO'
export const UPDATE_COUPON_INFO_FALSE = 'UPDATE_COUPON_INFO_FAlSE'
export const GENERATE_BY_COUPON_CODE = 'GENERATE_BY_COUPON_CODE'
export const COUPON_INFO_EXPIRED = 'COUPON_INFO_EXPIRED'



// WEBPACK FOOTER //
// ./src/pages/wx-member/member-coupon/store/mutations-types.js